import { render } from "./LoginButton.vue?vue&type=template&id=0203172a&scoped=true"
import script from "./LoginButton.vue?vue&type=script&lang=js"
export * from "./LoginButton.vue?vue&type=script&lang=js"

import "./LoginButton.vue?vue&type=style&index=0&id=0203172a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0203172a"]])

export default __exports__